import { StatsReport } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const QueryStatsIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <StatsReport width={size} height={size} color={color} {...rest} />;

QueryStatsIcon.displayName = 'QueryStatsIcon';

export default QueryStatsIcon;
